import { AppError } from 'src/app/common/app-error';

export class NotFoundError extends AppError { }
